import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        'relative overflow-hidden rounded-sm bg-skeleton',
        className,
      )}
      {...props}
    />
  );
}

Skeleton.displayName = 'Skeleton';

export { Skeleton };
